import { ElearningInfo } from "@otimo/highcharts-xmlreport";
import { ParamSetting } from "./param-setting";

export class ReportConfig {
    constructor(
        public title: string,
        public paramSettings: ParamSetting = new ParamSetting(),
        public canDrillDown: boolean = false,
        public drillDownTo: string = "",
        public canSerieDrillDown: boolean = false,
        public serieDrillDownList: string[] = [],
        public elearning: ElearningInfo = null
    ) { }
}